import { render, staticRenderFns } from "./ClassStudentSave.vue?vue&type=template&id=1dbab7fb&"
import script from "./ClassStudentSave.vue?vue&type=script&lang=js&"
export * from "./ClassStudentSave.vue?vue&type=script&lang=js&"
import style0 from "./ClassStudentSave.vue?vue&type=style&index=0&id=1dbab7fb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports